(function () {
  "use strict";

  var routes = window.KiRoutes || { root: "/", cartAdd: "/cart/add", cartChange: "/cart/change" };
  var drawerReturnFocus = null;
  var currentAudio = null;
  var currentSource = "";
  var currentTrigger = null;
  var bodyOverflow = "";
  var currentTrackInfo = null;
  var playerStateKey = "ki-player-state-v3";
  var playerStateTimer = null;
  var navigationController = null;

  function jsonRoute(path) {
    return /\.js(?:\?|$)/.test(path) ? path : path + ".js";
  }

  function toast(message) {
    var element = document.getElementById("KiToast");
    if (!element) return;
    element.textContent = message;
    element.classList.add("is-on");
    clearTimeout(element._timer);
    element._timer = setTimeout(function () { element.classList.remove("is-on"); }, 2400);
  }

  function buzz(event) {
    if (!navigator.vibrate) return;
    var node = event.target;
    var hops = 0;
    while (node && node.nodeType === 1 && hops < 5) {
      if (getComputedStyle(node).cursor === "pointer") {
        navigator.vibrate(8);
        return;
      }
      node = node.parentElement;
      hops += 1;
    }
  }
  window.addEventListener("pointerdown", buzz, { passive: true });

  /* ---------- cart drawer ---------- */
  function drawer() {
    return document.querySelector("[data-ki-drawer]");
  }

  function openDrawer(returnTo) {
    var element = drawer();
    if (!element) return;
    if (element.classList.contains("is-open")) return;
    drawerReturnFocus = returnTo || document.activeElement;
    bodyOverflow = document.body.style.overflow;
    element.classList.add("is-open");
    element.removeAttribute("inert");
    element.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    var close = element.querySelector(".ki-close");
    if (close) close.focus();
  }

  function closeDrawer() {
    var element = drawer();
    if (!element || !element.classList.contains("is-open")) return;
    if (drawerReturnFocus && drawerReturnFocus.focus) {
      try { drawerReturnFocus.focus({ preventScroll: true }); }
      catch (error) { drawerReturnFocus.focus(); }
    }
    element.classList.remove("is-open");
    element.setAttribute("aria-hidden", "true");
    element.setAttribute("inert", "");
    document.body.style.overflow = bodyOverflow;
    drawerReturnFocus = null;
  }

  async function refreshDrawer() {
    var sectionResponse = await fetch(routes.root + "?section_id=cart-drawer", { headers: { "Accept": "text/html" } });
    if (!sectionResponse.ok) throw new Error("Could not refresh cart");

    var html = await sectionResponse.text();
    var documentCopy = new DOMParser().parseFromString(html, "text/html");
    var fresh = documentCopy.querySelector("[data-ki-drawer]");
    var live = drawer();

    if (fresh && live) {
      var wasOpen = live.classList.contains("is-open");
      live.innerHTML = fresh.innerHTML;
      live.classList.toggle("is-open", wasOpen);
      live.setAttribute("aria-hidden", wasOpen ? "false" : "true");
      if (wasOpen) live.removeAttribute("inert");
      else live.setAttribute("inert", "");
      if (wasOpen) {
        var freshClose = live.querySelector(".ki-close");
        if (freshClose) freshClose.focus();
      }
    }

    var total = documentCopy.querySelector("[data-ki-cart-total]");
    document.querySelectorAll("[data-ki-cart-total]").forEach(function (node) {
      if (total) node.textContent = total.textContent;
    });

    try {
      var cartResponse = await fetch(routes.root + "cart.js", { headers: { "Accept": "application/json" } });
      if (cartResponse.ok) {
        var cart = await cartResponse.json();
        document.querySelectorAll("[data-ki-cart-count]").forEach(function (node) {
          node.textContent = String(cart.item_count || 0);
        });
      }
    } catch (error) {
      /* The drawer remains current even when the optional count request fails. */
    }
  }

  async function submitCartForm(form) {
    var button = form.querySelector("[data-ki-add-btn]");
    var originalLabel = button ? button.textContent : "";
    if (button) {
      button.disabled = true;
      button.textContent = "Adding…";
    }

    try {
      var response = await fetch(jsonRoute(routes.cartAdd), { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) });
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || "Could not add to cart");
      toast((result.product_title || "Added") + " · added");
      try {
        await refreshDrawer();
        openDrawer(button);
      } catch (refreshError) {
        window.location.href = routes.cart || routes.root + "cart";
      }
    } catch (error) {
      toast(error.message || "Could not add to cart");
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel;
        var selected = form.querySelector("[data-ki-variants] input:checked");
        if (selected) updateProductVariant(selected);
      }
    }
  }

  document.addEventListener("click", function (event) {
    var open = event.target.closest("[data-ki-cart-open]");
    if (open) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (event.target.closest("[data-ki-cart-close]")) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var remove = event.target.closest("[data-ki-remove]");
    if (remove) {
      event.preventDefault();
      var key = remove.getAttribute("data-ki-remove");
      remove.disabled = true;
      fetch(jsonRoute(routes.cartChange), {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function (response) {
        if (!response.ok) throw new Error("Could not remove item");
        toast("Removed");
        return refreshDrawer();
      }).catch(function () {
        window.location.href = routes.root + "cart";
      });
    }
  });

  document.addEventListener("keydown", function (event) {
    var element = drawer();
    if (event.key === "Escape" && element && element.classList.contains("is-open")) closeDrawer();
    if (event.key !== "Tab" || !element || !element.classList.contains("is-open")) return;

    var panel = element.querySelector(".ki-drawer__panel");
    var focusable = panel.querySelectorAll("a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex='-1'])");
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("[data-ki-add-form]");
    if (!form || !window.fetch) return;
    event.preventDefault();
    submitCartForm(form);
  });

  /* ---------- sticky player helpers ---------- */
  var sticky = document.getElementById("ki-sticky");
  var stickyPlay = document.getElementById("sticky-play");
  var stickyPrev = document.getElementById("sticky-prev");
  var stickyNext = document.getElementById("sticky-next");
  var stickyProgress = document.getElementById("sticky-progress");
  var stickyTimeCurrent = document.getElementById("sticky-time-current");
  var stickyTimeDuration = document.getElementById("sticky-time-duration");
  var stickyVolume = document.getElementById("sticky-volume");
  var stickyLicense = document.getElementById("sticky-license");
  var stickyTitle = document.getElementById("sticky-title");
  var stickyMeta = document.getElementById("sticky-meta");
  var stickyThumb = document.getElementById("sticky-thumb");
  var stickyThumbImage = document.getElementById("sticky-thumb-image");
  var stickyThumbMark = document.getElementById("sticky-thumb-mark");
  var stickyProductLinks = Array.prototype.slice.call(document.querySelectorAll("[data-ki-product-link]"));
  var trackBackdrop = document.getElementById("ki-track-bg");
  var trackBackdropLayers = trackBackdrop ? Array.prototype.slice.call(trackBackdrop.querySelectorAll("[data-ki-track-bg-layer]")) : [];
  var trackBackdropIndex = 0;
  var currentBackdrop = "";

  ["ki-player-state-v1", "ki-player-state-v2"].forEach(function (legacyKey) {
    try { sessionStorage.removeItem(legacyKey); } catch (error) { /* Ignore legacy storage cleanup failures. */ }
    try { localStorage.removeItem(legacyKey); } catch (error) { /* Ignore legacy storage cleanup failures. */ }
  });

  function readPlayerState() {
    var raw = null;
    try { raw = localStorage.getItem(playerStateKey); } catch (error) { /* Local storage can be disabled. */ }
    if (!raw) {
      try { raw = sessionStorage.getItem(playerStateKey); } catch (error) { /* Session storage can be disabled. */ }
    }
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (error) { return null; }
  }

  function writePlayerState(state) {
    var raw = JSON.stringify(state);
    try { localStorage.setItem(playerStateKey, raw); } catch (error) { /* Local storage can be disabled. */ }
    try { sessionStorage.setItem(playerStateKey, raw); } catch (error) { /* Session storage can be disabled. */ }
  }

  function syncPlayerClearance() {
    if (!sticky || !document.body.classList.contains("ki-player-visible")) {
      document.body.style.removeProperty("--ki-player-clearance");
      return;
    }
    var height = Math.ceil(sticky.getBoundingClientRect().height || sticky.offsetHeight || 0);
    if (height > 0) document.body.style.setProperty("--ki-player-clearance", height + "px");
  }

  function setTrackBackdrop(imageUrl, cssBackground) {
    if (!trackBackdrop || !trackBackdropLayers.length) return;
    var nextImage = String(imageUrl || "").trim();
    var nextCss = String(cssBackground || "").trim();
    var nextBackgroundKey = nextImage ? "image:" + nextImage : (nextCss ? "css:" + nextCss : "");
    if (!nextBackgroundKey) {
      currentBackdrop = "";
      trackBackdrop.classList.remove("is-active");
      document.body.classList.remove("ki-track-bg-active");
      trackBackdropLayers.forEach(function (layer) {
        layer.classList.remove("is-active");
        layer.style.background = "";
        layer.style.backgroundImage = "";
      });
      return;
    }
    if (nextBackgroundKey === currentBackdrop && trackBackdrop.classList.contains("is-active")) return;

    currentBackdrop = nextBackgroundKey;
    var nextIndex = trackBackdropLayers.length > 1 ? (trackBackdropIndex + 1) % trackBackdropLayers.length : 0;
    var nextLayer = trackBackdropLayers[nextIndex];
    var previousLayer = trackBackdropLayers[trackBackdropIndex];

    nextLayer.style.background = "";
    nextLayer.style.backgroundImage = "";
    if (nextImage) nextLayer.style.backgroundImage = 'url("' + nextImage.replace(/\"/g, "%22") + '")';
    else nextLayer.style.background = nextCss;
    nextLayer.style.backgroundPosition = "center";
    nextLayer.style.backgroundSize = "cover";
    nextLayer.style.backgroundRepeat = "no-repeat";
    nextLayer.classList.add("is-active");
    trackBackdrop.classList.add("is-active");
    document.body.classList.add("ki-track-bg-active");

    requestAnimationFrame(function () {
      if (previousLayer && previousLayer !== nextLayer) previousLayer.classList.remove("is-active");
      trackBackdropIndex = nextIndex;
    });
  }

  function applyTrackBackdrop(info) {
    if (!info) { setTrackBackdrop("", ""); return; }
    // Generated beat art is the authoritative visual identity for the player/site color state.
    // Prefer it over a product photo so switching beats always changes to that beat's palette.
    var generatedArt = String(info.artCss || info.backdropCss || info.backdrop || "").trim();
    if (generatedArt) {
      setTrackBackdrop("", generatedArt);
      return;
    }
    setTrackBackdrop(info.backdropUrl || info.image || "", "");
  }

  function trackImageFromTrigger(trigger) {
    if (!trigger) return "";
    var explicit = trigger.getAttribute("data-ki-image") || "";
    if (explicit) return explicit;
    var shell = trigger.closest(".ki-cover, .ki-product, .ki-beat-row, .ki-brand-feature, article, li");
    var image = shell ? shell.querySelector("img[src]") : null;
    return image ? (image.currentSrc || image.getAttribute("src") || "") : "";
  }

  function trackInfoFromTrigger(trigger) {
    if (!trigger) return null;
    return {
      trackId: trigger.getAttribute("data-ki-track-id") || "",
      title: trigger.getAttribute("data-ki-title") || "Preview",
      meta: trigger.getAttribute("data-ki-meta") || "",
      image: trackImageFromTrigger(trigger),
      backdropUrl: trigger.getAttribute("data-ki-backdrop-url") || "",
      backdropCss: trigger.getAttribute("data-ki-backdrop-css") || "",
      backdrop: trigger.getAttribute("data-ki-backdrop") || "",
      artCss: trigger.getAttribute("data-ki-art-css") || trigger.getAttribute("data-ki-backdrop-css") || "",
      productUrl: trigger.getAttribute("data-ki-product-url") || routes.root + "collections/all",
      available: trigger.getAttribute("data-ki-available") !== "false"
    };
  }

  function normalizeProductPath(value) {
    try { return new URL(value || "", window.location.href).pathname.replace(/\/$/, ""); }
    catch (error) { return String(value || "").split("?")[0].replace(/\/$/, ""); }
  }

  function sameTrackInfo(a, b) {
    if (!a || !b) return false;
    if (a.trackId && b.trackId) return String(a.trackId) === String(b.trackId);
    var aPath = normalizeProductPath(a.productUrl);
    var bPath = normalizeProductPath(b.productUrl);
    return !!aPath && aPath === bPath;
  }

  function applyStickyInfo(info) {
    if (!sticky || !info) return;
    currentTrackInfo = info;
    applyTrackBackdrop(info);
    sticky.classList.add("ki-sticky--active");
    document.body.classList.add("ki-player-visible");
    sticky.setAttribute("aria-hidden", "false");
    requestAnimationFrame(syncPlayerClearance);
    if (stickyTitle) stickyTitle.textContent = info.title || "Preview";
    if (stickyMeta) stickyMeta.textContent = info.meta || "";
    if (stickyThumb) {
      var productImage = String(info.image || info.backdropUrl || "").trim();
      var generatedArt = String(info.artCss || info.backdropCss || info.backdrop || "").trim();
      var useGeneratedArt = !!generatedArt;

      // IMPORTANT: art-bg outputs multiple gradient layers PLUS a terminal base color.
      // That is valid for the shorthand `background`, but invalid as `background-image`.
      // Using backgroundImage here caused v1.4.11's generated colors to disappear.
      stickyThumb.style.background = useGeneratedArt ? generatedArt : "none";
      stickyThumb.style.backgroundColor = "transparent";
      stickyThumb.classList.toggle("has-generated-art", useGeneratedArt);
      stickyThumb.classList.toggle("has-image", !useGeneratedArt && !!productImage);

      if (stickyThumbImage) {
        if (!useGeneratedArt && productImage) {
          if (stickyThumbImage.getAttribute("src") !== productImage) stickyThumbImage.setAttribute("src", productImage);
          stickyThumbImage.hidden = false;
          stickyThumbImage.removeAttribute("hidden");
        } else {
          stickyThumbImage.hidden = true;
          stickyThumbImage.setAttribute("hidden", "");
          stickyThumbImage.removeAttribute("src");
        }
      }
      if (stickyThumbMark) {
        stickyThumbMark.hidden = !useGeneratedArt;
        if (useGeneratedArt) stickyThumbMark.removeAttribute("hidden");
        else stickyThumbMark.setAttribute("hidden", "");
      }
    }
    var productUrl = info.productUrl || routes.root + "collections/all";
    stickyProductLinks.forEach(function (link) {
      link.setAttribute("href", productUrl);
      if (link === stickyThumb) link.setAttribute("aria-label", "View " + (info.title || "current beat"));
    });
    if (stickyLicense) {
      stickyLicense.setAttribute("href", productUrl);
      stickyLicense.textContent = info.available === false ? "View beat" : "Choose license";
    }
  }

  function updateSticky(trigger) {
    var info = trackInfoFromTrigger(trigger);
    if (!info) return;
    applyStickyInfo(info);
  }

  function formatPlayerTime(seconds) {
    var safe = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
    var minutes = Math.floor(safe / 60);
    var remainder = String(safe % 60).padStart(2, "0");
    return minutes + ":" + remainder;
  }

  function updatePlayerProgress() {
    if (!stickyProgress) return;
    var duration = currentAudio && Number.isFinite(currentAudio.duration) && currentAudio.duration > 0 ? currentAudio.duration : 0;
    var time = currentAudio && Number.isFinite(currentAudio.currentTime) ? Math.max(0, currentAudio.currentTime) : 0;
    stickyProgress.disabled = !duration;
    stickyProgress.value = duration ? String(Math.round(Math.min(1, time / duration) * 1000)) : "0";
    if (stickyTimeCurrent) stickyTimeCurrent.textContent = formatPlayerTime(time);
    if (stickyTimeDuration) stickyTimeDuration.textContent = formatPlayerTime(duration);
  }

  function savePlayerState(immediate) {
    if (!currentAudio || !currentSource || !currentTrackInfo) return;
    var audioSnapshot = currentAudio;
    var sourceSnapshot = currentSource;
    var infoSnapshot = Object.assign({}, currentTrackInfo);
    var write = function () {
      playerStateTimer = null;
      if (audioSnapshot !== currentAudio || sourceSnapshot !== currentSource) return;
      writePlayerState({
        source: sourceSnapshot,
        time: Number.isFinite(audioSnapshot.currentTime) ? audioSnapshot.currentTime : 0,
        playing: !audioSnapshot.paused && !audioSnapshot.ended,
        volume: Number.isFinite(audioSnapshot.volume) ? audioSnapshot.volume : 1,
        info: infoSnapshot,
        savedAt: Date.now()
      });
    };

    if (immediate) {
      if (playerStateTimer) clearTimeout(playerStateTimer);
      write();
      return;
    }
    if (!playerStateTimer) playerStateTimer = setTimeout(write, 350);
  }

  function clearPlayerState() {
    if (playerStateTimer) clearTimeout(playerStateTimer);
    playerStateTimer = null;
    try { sessionStorage.removeItem(playerStateKey); } catch (error) { /* Storage can be disabled. */ }
    try { localStorage.removeItem(playerStateKey); } catch (error) { /* Storage can be disabled. */ }
  }

  function findCurrentTrigger(scope, infoOverride, sourceOverride) {
    var root = scope || document;
    var targetInfo = infoOverride || currentTrackInfo || {};
    var targetSource = sourceOverride || currentSource || "";
    var candidates = Array.prototype.slice.call(root.querySelectorAll("[data-ki-audio]"));
    var match = null;

    /* Product identity is authoritative. Never fall through to an audio-URL match when
       we already know which Shopify product is playing: multiple products can share
       the same fallback/preview URL, and the old fallback could select the first beat
       on the destination page and silently replace the active track. */
    if (targetInfo.trackId) {
      match = candidates.find(function (button) { return button.getAttribute("data-ki-track-id") === String(targetInfo.trackId); }) || null;
      if (match) { currentTrigger = match; return match; }
    }
    if (targetInfo.productUrl) {
      var targetPath = normalizeProductPath(targetInfo.productUrl);
      match = candidates.find(function (button) { return normalizeProductPath(button.getAttribute("data-ki-product-url")) === targetPath; }) || null;
      currentTrigger = match;
      return match;
    }

    /* Audio URL is a legacy last resort only when no stable product identity exists. */
    if (targetSource) {
      match = candidates.find(function (button) { return button.getAttribute("data-ki-audio") === targetSource; }) || null;
    }

    currentTrigger = match;
    return match;
  }

  function syncVolumeControl() {
    if (stickyVolume && currentAudio) stickyVolume.value = String(Math.max(0, Math.min(1, currentAudio.volume)));
  }

  function bindAudioEvents(audio) {
    if (!audio) return;
    audio.addEventListener("play", function () {
      if (audio !== currentAudio) return;
      syncPlaybackState(true);
      updatePlayerProgress();
      savePlayerState(true);
    });
    audio.addEventListener("pause", function () {
      if (audio !== currentAudio) return;
      syncPlaybackState(false);
      updatePlayerProgress();
      savePlayerState(true);
    });
    audio.addEventListener("timeupdate", function () {
      if (audio !== currentAudio) return;
      updatePlayerProgress();
      savePlayerState(false);
    });
    audio.addEventListener("loadedmetadata", function () {
      if (audio === currentAudio) updatePlayerProgress();
    });
    audio.addEventListener("durationchange", function () {
      if (audio === currentAudio) updatePlayerProgress();
    });
    audio.addEventListener("volumechange", function () {
      if (audio !== currentAudio) return;
      syncVolumeControl();
      savePlayerState(false);
    });
    audio.addEventListener("ended", function () {
      if (audio !== currentAudio) return;
      syncPlaybackState(false);
      updatePlayerProgress();
      savePlayerState(true);
    });
    audio.addEventListener("error", function () {
      if (audio !== currentAudio) return;
      syncPlaybackState(false);
      toast("Preview could not play");
    });
  }

  function restorePlayerState() {
    var state = readPlayerState();
    if (!state || !state.source || !state.info) return;
    if (state.savedAt && Date.now() - state.savedAt > 21600000) {
      clearPlayerState();
      return;
    }

    currentTrackInfo = state.info;
    var liveTrigger = findCurrentTrigger(document, currentTrackInfo, state.source);
    if (liveTrigger) {
      var liveInfo = trackInfoFromTrigger(liveTrigger);
      if (liveInfo) currentTrackInfo = Object.assign({}, currentTrackInfo || {}, liveInfo);
      currentSource = liveTrigger.getAttribute("data-ki-audio") || state.source;
    } else {
      currentSource = state.source;
    }

    currentAudio = new Audio(currentSource);
    currentAudio.preload = "auto";
    if (typeof state.volume === "number") currentAudio.volume = Math.max(0, Math.min(1, state.volume));
    bindAudioEvents(currentAudio);
    applyStickyInfo(currentTrackInfo);
    syncPlaybackState(false);
    syncVolumeControl();
    updatePlayerProgress();

    var restoreTime = function () {
      try {
        if (typeof state.time === "number" && Number.isFinite(state.time) && state.time > 0) {
          currentAudio.currentTime = Math.max(0, Math.min(state.time, Number.isFinite(currentAudio.duration) ? currentAudio.duration : state.time));
        }
      } catch (error) { /* Some streams cannot seek before metadata is ready. */ }
      updatePlayerProgress();
      if (state.playing) {
        currentAudio.play().catch(function () {
          syncPlaybackState(false);
          savePlayerState(true);
        });
      }
    };

    if (currentAudio.readyState >= 1) restoreTime();
    else currentAudio.addEventListener("loadedmetadata", restoreTime, { once: true });
  }

  /* ---------- collection filters ---------- */
  function setFilterDrawer(open) {
    document.body.classList.toggle("ki-filters-open", !!open);
    document.querySelectorAll("[data-ki-filter-toggle]").forEach(function (button) {
      button.setAttribute("aria-expanded", String(!!open));
    });
  }

  function submitCollectionFilters(form) {
    if (!form) return;
    var url;
    try { url = new URL(form.action || window.location.href, window.location.href); }
    catch (error) { return; }

    var clean = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      var normalized = String(value == null ? "" : value).trim();
      if (normalized !== "") clean.append(key, normalized);
    });
    clean.delete("page");
    url.search = clean.toString();
    setFilterDrawer(false);
    navigateStorefront(url.toString(), true);
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest && event.target.closest("[data-ki-filter-form]");
    if (!form) return;
    event.preventDefault();
    submitCollectionFilters(form);
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-ki-filter-toggle]")) {
      event.preventDefault();
      setFilterDrawer(true);
      var panel = document.querySelector("[data-ki-filter-panel]");
      var first = panel && panel.querySelector("input:not([disabled]), button, summary");
      if (first && first.focus) window.setTimeout(function () { first.focus(); }, 40);
      return;
    }
    if (event.target.closest("[data-ki-filter-close], [data-ki-filter-overlay]")) {
      event.preventDefault();
      setFilterDrawer(false);
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && document.body.classList.contains("ki-filters-open")) setFilterDrawer(false);
  });

  document.addEventListener("ki:navigation:complete", function () { setFilterDrawer(false); });

  /* ---------- product variants ---------- */
  function updateProductVariant(input) {
    var root = input.closest("[data-ki-variants]");
    if (!root) return;
    var form = root.closest("form");
    var product = root.closest(".ki-product");
    var priceElement = product ? product.querySelector("[data-ki-product-price]") : null;
    var addButton = form ? form.querySelector("[data-ki-add-btn]") : null;

    root.querySelectorAll(".ki-variant").forEach(function (label) { label.classList.remove("ki-variant--on"); });
    var label = input.closest(".ki-variant");
    if (label) label.classList.add("ki-variant--on");

    var price = input.getAttribute("data-price") || "";
    var available = input.getAttribute("data-available") === "true";
    if (priceElement) priceElement.textContent = price;
    if (addButton) {
      addButton.disabled = !available;
      addButton.textContent = available ? "Add to cart — " + price : "Sold out";
    }

    if (product) {
      product.querySelectorAll("[data-ki-audio]").forEach(function (trigger) {
        trigger.setAttribute("data-ki-variant-id", input.value);
        trigger.setAttribute("data-ki-price", price);
        trigger.setAttribute("data-ki-available", String(available));
      });
    }
    if (currentTrigger && product && product.contains(currentTrigger)) updateSticky(currentTrigger);
    if (window.history && window.history.replaceState) {
      var variantUrl = new URL(window.location.href);
      variantUrl.searchParams.set("variant", input.value);
      window.history.replaceState({}, "", variantUrl);
    }
  }

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-ki-variants] input[type=radio]");
    if (input) {
      updateProductVariant(input);
      return;
    }

    var select = event.target.closest("[data-ki-sort]");
    if (select) {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", select.value);
      url.searchParams.delete("page");
      navigateStorefront(url.toString(), true);
      return;
    }

    var filterInput = event.target.closest("[data-ki-filter-input]");
    if (filterInput) {
      submitCollectionFilters(filterInput.closest("[data-ki-filter-form]"));
    }
  });

  /* ---------- grid/list view toggles ---------- */
  function normalizedView(view, fallback) {
    if (view === "grid" || view === "list") return view;
    return fallback === "grid" ? "grid" : "list";
  }

  function setView(root, view) {
    var selected = normalizedView(view, root.getAttribute("data-default-view"));
    root.classList.toggle("ki-list-view", selected === "list");
    root.classList.toggle("ki-grid-view", selected === "grid");
    root.querySelectorAll("[data-ki-view]").forEach(function (button) {
      button.setAttribute("aria-pressed", String(button.getAttribute("data-ki-view") === selected));
    });
  }

  function initializeCollections(scope) {
    var collections = [];
    if (scope.matches && scope.matches("[data-ki-collection]")) collections.push(scope);
    scope.querySelectorAll("[data-ki-collection]").forEach(function (root) { collections.push(root); });
    var stored = null;
    try { stored = localStorage.getItem("ki-view"); } catch (error) { /* Storage can be disabled. */ }
    collections.forEach(function (root) { setView(root, stored || root.getAttribute("data-default-view")); });
  }

  initializeCollections(document);
  document.addEventListener("shopify:section:load", function (event) { initializeCollections(event.target); });
  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-ki-view]");
    if (!button) return;
    var root = button.closest("[data-ki-collection]");
    var view = normalizedView(button.getAttribute("data-ki-view"), root ? root.getAttribute("data-default-view") : "list");
    try { localStorage.setItem("ki-view", view); } catch (error) { /* Keep the current view. */ }
    document.querySelectorAll("[data-ki-collection]").forEach(function (collection) { setView(collection, view); });
  });

  /* ---------- seamless storefront navigation ---------- */
  function isCheckoutOrSystemPath(url) {
    var path = url.pathname || "/";
    return /^\/(checkout|checkouts|account|challenge|payments|admin)(?:\/|$)/i.test(path);
  }

  function shouldHandleStorefrontLink(anchor, event) {
    if (!anchor || !anchor.href || event.defaultPrevented) return false;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.hasAttribute("download") || anchor.getAttribute("target") === "_blank") return false;
    if (anchor.getAttribute("data-ki-full-navigation") != null) return false;
    var url;
    try { url = new URL(anchor.href, window.location.href); } catch (error) { return false; }
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return false;
    if (isCheckoutOrSystemPath(url)) return false;
    if (/\.(?:mp3|wav|aiff?|flac|m4a|zip|pdf)(?:$|\?)/i.test(url.pathname + url.search)) return false;

    var current = new URL(window.location.href);
    if (url.pathname === current.pathname && url.search === current.search && url.hash) return false;
    return true;
  }

  function copyHeadElement(selector, freshDocument) {
    var fresh = freshDocument.querySelector(selector);
    var live = document.querySelector(selector);
    if (!fresh) {
      if (live && live.parentNode) live.parentNode.removeChild(live);
      return;
    }
    if (!live) {
      live = fresh.cloneNode(true);
      document.head.appendChild(live);
      return;
    }
    Array.from(live.attributes).forEach(function (attribute) { live.removeAttribute(attribute.name); });
    Array.from(fresh.attributes).forEach(function (attribute) { live.setAttribute(attribute.name, attribute.value); });
    if (fresh.textContent !== live.textContent) live.textContent = fresh.textContent;
  }

  function reactivateScripts(scope) {
    scope.querySelectorAll("script").forEach(function (oldScript) {
      var script = document.createElement("script");
      Array.from(oldScript.attributes).forEach(function (attribute) {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(script, oldScript);
    });
  }

  function syncCurrentNavigation(destination) {
    var activeUrl;
    try { activeUrl = new URL(destination || window.location.href, window.location.href); } catch (error) { return; }
    document.querySelectorAll(".ki-nav a").forEach(function (anchor) {
      var linkUrl;
      try { linkUrl = new URL(anchor.href, window.location.href); } catch (error) { return; }
      var active = linkUrl.origin === activeUrl.origin && linkUrl.pathname.replace(/\/$/, "") === activeUrl.pathname.replace(/\/$/, "");
      if (active) anchor.setAttribute("aria-current", "page");
      else anchor.removeAttribute("aria-current");
    });
  }

  function finishStorefrontNavigation(freshDocument, finalUrl, pushState) {
    var liveMain = document.getElementById("MainContent");
    var freshMain = freshDocument.getElementById("MainContent");
    if (!liveMain || !freshMain) throw new Error("Page content could not be loaded");

    liveMain.innerHTML = freshMain.innerHTML;
    liveMain.className = freshMain.className;
    liveMain.removeAttribute("aria-busy");
    reactivateScripts(liveMain);

    document.title = freshDocument.title || document.title;
    copyHeadElement('link[rel="canonical"]', freshDocument);
    copyHeadElement('meta[name="description"]', freshDocument);

    if (pushState) window.history.pushState({ kiNavigation: true }, "", finalUrl);
    initializeCollections(liveMain);
    var liveTrackTrigger = findCurrentTrigger(liveMain);
    if (liveTrackTrigger) {
      var liveTrackInfo = trackInfoFromTrigger(liveTrackTrigger);
      if (liveTrackInfo) currentTrackInfo = Object.assign({}, currentTrackInfo || {}, liveTrackInfo);
    }
    if (currentTrackInfo) applyStickyInfo(currentTrackInfo);
    syncPlaybackState(!!(currentAudio && !currentAudio.paused && !currentAudio.ended));
    syncCurrentNavigation(finalUrl);
    var finalLocation = new URL(finalUrl, window.location.href);
    var hashTarget = finalLocation.hash ? document.getElementById(decodeURIComponent(finalLocation.hash.slice(1))) : null;
    if (hashTarget && hashTarget.scrollIntoView) hashTarget.scrollIntoView();
    else window.scrollTo(0, 0);
    document.dispatchEvent(new CustomEvent("ki:navigation:complete", { detail: { url: finalUrl } }));
  }

  function storefrontRequestUrl(url) {
    var requestUrl = new URL(url.href);
    if (!(window.Shopify && window.Shopify.designMode)) return requestUrl;

    /* Shopify's theme editor runs the storefront inside a preview context. Keep the
       preview parameters on AJAX page requests so seamless navigation stays on the
       theme being edited instead of accidentally resolving against another theme. */
    var currentUrl;
    try { currentUrl = new URL(window.location.href); } catch (error) { return requestUrl; }
    ["preview_theme_id", "_fd", "pb"].forEach(function (key) {
      if (!requestUrl.searchParams.has(key) && currentUrl.searchParams.has(key)) {
        requestUrl.searchParams.set(key, currentUrl.searchParams.get(key));
      }
    });
    return requestUrl;
  }

  function navigateStorefront(destination, pushState) {
    var url;
    try { url = new URL(destination, window.location.href); } catch (error) { window.location.href = destination; return; }
    if (url.origin !== window.location.origin || isCheckoutOrSystemPath(url)) {
      window.location.href = url.href;
      return;
    }

    var requestUrl = storefrontRequestUrl(url);
    if (navigationController) navigationController.abort();
    navigationController = window.AbortController ? new AbortController() : null;
    savePlayerState(true);
    var liveMain = document.getElementById("MainContent");
    if (liveMain) liveMain.setAttribute("aria-busy", "true");

    fetch(requestUrl.href, {
      method: "GET",
      credentials: "same-origin",
      headers: { "Accept": "text/html", "X-Requested-With": "KashIslandTheme" },
      signal: navigationController ? navigationController.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error("Navigation failed");
      var responseUrl = new URL(response.url || url.href, window.location.href);
      if (responseUrl.origin !== window.location.origin || isCheckoutOrSystemPath(responseUrl)) {
        window.location.href = responseUrl.href;
        return null;
      }
      return response.text().then(function (html) { return { html: html, url: responseUrl.href }; });
    }).then(function (result) {
      if (!result) return;
      var freshDocument = new DOMParser().parseFromString(result.html, "text/html");
      finishStorefrontNavigation(freshDocument, result.url, pushState !== false);
    }).catch(function (error) {
      if (error && error.name === "AbortError") return;
      window.location.href = url.href;
    }).finally(function () {
      var main = document.getElementById("MainContent");
      if (main) main.removeAttribute("aria-busy");
      navigationController = null;
    });
  }

  document.addEventListener("click", function (event) {
    var anchor = event.target.closest("a[href]");
    if (!shouldHandleStorefrontLink(anchor, event)) return;
    event.preventDefault();
    navigateStorefront(anchor.href, true);
  });

  window.addEventListener("popstate", function () {
    navigateStorefront(window.location.href, false);
  });

  /* ---------- audio preview + sticky player ---------- */
  function syncPlaybackState(playing) {
    document.querySelectorAll("[data-ki-audio]").forEach(function (button) {
      var info = trackInfoFromTrigger(button);
      var isCurrent = sameTrackInfo(info, currentTrackInfo) || (!currentTrackInfo && button.getAttribute("data-ki-audio") === currentSource);
      button.classList.toggle("is-playing", !!(isCurrent && playing));
      button.setAttribute("aria-pressed", String(isCurrent && playing));
      button.setAttribute("aria-label", isCurrent && playing
        ? button.getAttribute("data-ki-pause-label") || "Pause"
        : button.getAttribute("data-ki-play-label") || "Play preview");
    });
    if (stickyPlay) {
      stickyPlay.classList.toggle("is-playing", !!playing);
      stickyPlay.setAttribute("aria-label", playing
        ? stickyPlay.getAttribute("data-ki-pause-label") || "Pause"
        : stickyPlay.getAttribute("data-ki-play-label") || "Play");
    }
  }

  function toggleCurrentAudio() {
    if (!currentAudio) return;
    if (currentAudio.paused) {
      currentAudio.play().then(function () { syncPlaybackState(true); }).catch(function () { toast("Preview could not play"); });
    } else {
      currentAudio.pause();
      syncPlaybackState(false);
    }
  }

  function activateTrack(trigger, toggleIfCurrent) {
    if (!trigger) return;
    var source = trigger.getAttribute("data-ki-audio") || "";
    if (!source) {
      toast("No preview uploaded for this beat");
      return;
    }

    var nextInfo = trackInfoFromTrigger(trigger);
    var isCurrent = currentAudio && (sameTrackInfo(nextInfo, currentTrackInfo) || currentSource === source);
    if (isCurrent) {
      currentTrigger = trigger;
      currentTrackInfo = Object.assign({}, currentTrackInfo || {}, nextInfo || {});
      updateSticky(trigger);
      if (toggleIfCurrent !== false) toggleCurrentAudio();
      return;
    }

    var previousAudio = currentAudio;
    var previousVolume = previousAudio && Number.isFinite(previousAudio.volume) ? previousAudio.volume : (stickyVolume ? Number(stickyVolume.value) : 1);

    /* Detach the old audio from global state before pausing it. This prevents its pause event from overwriting the new track in storage. */
    currentAudio = null;
    if (previousAudio && !previousAudio.paused) previousAudio.pause();

    currentSource = source;
    currentTrigger = trigger;
    currentTrackInfo = nextInfo;
    currentAudio = new Audio(source);
    currentAudio.preload = "auto";
    if (Number.isFinite(previousVolume)) currentAudio.volume = Math.max(0, Math.min(1, previousVolume));
    bindAudioEvents(currentAudio);
    applyStickyInfo(currentTrackInfo);
    syncVolumeControl();
    updatePlayerProgress();

    /* Commit the newly selected track immediately, before the asynchronous play promise resolves. */
    savePlayerState(true);
    var requestedAudio = currentAudio;
    currentAudio.play().then(function () {
      if (currentAudio !== requestedAudio) return;
      syncPlaybackState(true);
      savePlayerState(true);
    }).catch(function () {
      if (currentAudio !== requestedAudio) return;
      syncPlaybackState(false);
      savePlayerState(true);
      toast("Preview could not play");
    });
  }

  function playlistTriggers() {
    var seen = {};
    return Array.prototype.slice.call(document.querySelectorAll("[data-ki-audio]:not([disabled])")).filter(function (button) {
      var source = button.getAttribute("data-ki-audio") || "";
      var info = trackInfoFromTrigger(button);
      var key = info && info.trackId ? "id:" + info.trackId : (info && info.productUrl ? "url:" + normalizeProductPath(info.productUrl) : "src:" + source);
      if (!source || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function playAdjacentTrack(offset) {
    var tracks = playlistTriggers();
    if (!tracks.length) {
      toast("No other previews on this page");
      return;
    }
    var currentIndex = tracks.findIndex(function (button) {
      return sameTrackInfo(trackInfoFromTrigger(button), currentTrackInfo) || button.getAttribute("data-ki-audio") === currentSource;
    });
    var nextIndex;
    if (currentIndex < 0) nextIndex = offset < 0 ? tracks.length - 1 : 0;
    else nextIndex = (currentIndex + offset + tracks.length) % tracks.length;
    activateTrack(tracks[nextIndex], false);
  }

  document.addEventListener("input", function (event) {
    if (event.target === stickyProgress && currentAudio && Number.isFinite(currentAudio.duration) && currentAudio.duration > 0) {
      currentAudio.currentTime = (Number(stickyProgress.value) / 1000) * currentAudio.duration;
      updatePlayerProgress();
      savePlayerState(false);
      return;
    }
    if (event.target === stickyVolume && currentAudio) {
      currentAudio.volume = Math.max(0, Math.min(1, Number(stickyVolume.value)));
    }
  });

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-ki-audio]");
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      activateTrack(trigger, true);
      return;
    }

    if (event.target.closest("#sticky-play")) {
      event.preventDefault();
      toggleCurrentAudio();
      return;
    }

    if (event.target.closest("#sticky-prev")) {
      event.preventDefault();
      playAdjacentTrack(-1);
      return;
    }

    if (event.target.closest("#sticky-next")) {
      event.preventDefault();
      playAdjacentTrack(1);
      return;
    }

    if (event.target.closest("#sticky-close")) {
      var closingAudio = currentAudio;
      currentAudio = null;
      if (closingAudio && !closingAudio.paused) closingAudio.pause();
      syncPlaybackState(false);
      sticky.classList.remove("ki-sticky--active");
      document.body.classList.remove("ki-player-visible");
      syncPlayerClearance();
      sticky.setAttribute("aria-hidden", "true");
      clearPlayerState();
      setTrackBackdrop("", "");
      currentSource = "";
      currentTrackInfo = null;
      updatePlayerProgress();
      if (currentTrigger && document.contains(currentTrigger)) currentTrigger.focus();
      currentTrigger = null;
      return;
    }
  });

  restorePlayerState();
  window.addEventListener("resize", syncPlayerClearance, { passive: true });
  syncCurrentNavigation(window.location.href);
  window.addEventListener("pagehide", function () { savePlayerState(true); });
  window.addEventListener("beforeunload", function () { savePlayerState(true); });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") savePlayerState(true);
  });
})();
